import React from 'react';
import { Menu, MenuProps } from 'antd';
import { FormOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../../types/types';
import { tablesSlice } from '../../../tables/TablesSlice';
import { useAppDispatch } from '../../../../core/redux';
import s from './Navigation.module.scss';

type MenuItem = Required<MenuProps>['items'][number];

const getItem = (
  label: React.ReactNode,
  key?: React.Key | null,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem => {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
};

let items: MenuItem[] = [
  getItem('Проекты', 'projects', <FormOutlined />, [
    getItem('Все проекты', 'allProjects'),
    // getItem('Option 4', '4'),
  ]),
  // getItem('Логи', routes.logs, <CheckCircleOutlined />),
  getItem('Пользователи', routes.users, <UserOutlined />),
];
const { setDocumentTab } = tablesSlice.actions;

export const Navigation = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const onClick: MenuProps['onClick'] = (e) => {
    navigate(e.keyPath.reverse().join('/'));
    dispatch(setDocumentTab('general'));
  };
  if (process.env?.REACT_APP_OAUTH2 === 'true') {
    items = items.filter((i) => i.key !== routes.users);
  }
  return (
    <div className={s.Navigation}>
      <Menu
        onClick={onClick}
        style={{ width: 256 }}
        defaultSelectedKeys={['allProjects']}
        defaultOpenKeys={['projects']}
        mode={'inline'}
        items={items}
      />
      <div style={{ padding: '0 24px' }}>
        XMLEditor V{process.env?.REACT_APP_VERTION || '0.0.0'}
      </div>
    </div>
  );
};
